import React from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import { NavDropdown } from "react-bootstrap";
import * as moment from "moment";
import "moment/locale/de";
import { toast } from "react-toastify";

// Actions
import { vorgangeDetailsActions } from "../../store/actions/vorgange/vorgangeDetailsActions";
import { userActions } from "../../store/actions/userActions";
import { verimiAdminActions } from "../../store/actions/admin/verimiAdminActions";
import { manualRequestFormActions } from "../../store/actions/vorgange/manualRequestFormActions";
import { VollmachtRequestFormAction } from "../../store/actions/vorgange/VollmachtRequestFormAction";

import MDCLicensePlate from "../core/MDCLicensePlate";

import AntragRequestForm from "../manualRequest/AntragRequestForm";
import FahrzeugRequestForm from "../manualRequest/FahrzeugRequestForm";
import KennzeichenRequestForm from "../manualRequest/KennzeichenRequestForm";
import HalterRequestForm from "../manualRequest/HalterRequestForm";
import VollmachtTab from "../manualRequest/vollmacht/VollmachtTab";
import GebuhrenDetails from "../manualRequest/GebuhrenDetails";
import MassageDialog from "../shared/MessageDialog";
import ArchiveRecordDialog from "./ArchiveRecordDialog";

// Assets
import errorIcon from "../../assets/images/Icon_error.svg";
import checkIcon from "../../assets/images/icon_check.svg";
import blackCheckIcon from "../../assets/images/icon_check_black.svg";
import DownloadImage from "../../assets/images/Icon_Download.svg";
import iconQESCompletionGreen from "../../assets/images/icon_vollmacht_green.svg";
import iconQESCompletionBlack from "../../assets/images/icon_vollmacht_black.svg";

// Constants
import { ABORT } from "../../constants/messageConstants";
import PopupDialog from "../shared/PopupDialog";
import DataRegistrationDialog from "./DataRegistrationDialog";
import VerwerfenPopupDialog from "../shared/VerwerfenPopupDialog";
import {
  QESFilesName,
  DataRegistrationFilesName,
  ZulassungsFilesName,
  RejectedAbgelehntFilesName,
  TEIL1,
  TEIL2,
  TEIL3,
  TEIL1_ENDPOINT,
  TEIL2_ENDPOINT,
  TEIL3_ENDPOINT,
  abmeldebescheinigung,
  ABZulassungsFilesName,
  HTTP_SUCCESS_CODE_200,
  RRCDocumentFilesName,
  TENANT_STATUSES,
} from "../../constants/VorgangDetailsConstants";
import {
  USER_ROLE_ADMIN,
  USER_ROLE_APPROVER,
  USER_ROLE_SUPPORT,
  QES_CURRENT_STAGE,
  QES_STAGE_STATUS,
} from "../../constants/userConstants";

// Helper
import {
  formTag,
  antragDefaultForm,
  fahrzeugDefaultForm,
  kennzeichenDefaultForm,
  halterDefaultForm,
  vollmachtDefaultForm,
  getTabObjects,
  updateStateObject,
} from "../../helpers/vorgange";
import {
  createIsolatedFormDefaults,
  cleanupIsolatedState,
  COMPONENT_CONTEXTS,
} from "../../helpers/vorgangStateIsolation";
import {
  convertBase64StringToBlobURL,
  downloadFileWithBlobURL,
  getActiveUserTenantAlias,
  getFileNameFromHttpResponse,
  hasRolePermissions,
} from "../../helpers/utils";
import {
  ConfirmationPopupConstants,
  MessageDetailsDialogConstants,
} from "../../constants/PopupDialogConstants";
import {
  VORGANT_STATUS_ABGELEHNT,
  VORGANT_STATUS_EINGEREICHT,
  VORGANT_STATUS_FEHLER,
  VORGANT_STATUS_FEHLER_B,
  VORGANT_STATUS_FEHLER_T,
  VORGANT_STATUS_GENEHMIGT,
  VORGANT_STATUS_VERSANDFERTIG,
} from "../../constants/DashboardConstants";
import {
  NO_CONTENT_FILE_DOWNLOAD,
  PDF_FILE_TYPE,
} from "../../constants/ManualRequestFormConstants";

// History
import { history } from "../../helpers/history";

// Core Components
import MDCButton from "../../components/core/MDCButton";
import MDCModal from "../core/MDCModal";
import { withStyles } from "@mui/styles";
import MDCLoader from "../core/MDCLoader";
import MDCTooltip from "../core/MDCTooltip";
import { alertCSS, alertInfoCSS, alertErrorCSS } from "../shared/AlertCSS";

//Button Icons
import BlockIcon from "../iconComponents/BlockIcon";
import NextIcon from "../iconComponents/NextIcon";
import RefreshIcon from "../iconComponents/RefreshIcon";
import EditIcon from "../iconComponents/EditIcon";
import ButtonDocumentIcon from "../iconComponents/ButtonDocumentIcon";
import DownArrowIcon from "../iconComponents/DownArrowIcon";
import UpArrowIcon from "../iconComponents/UpArrowIcon";
import ArchiveIcon from "../iconComponents/ArchiveIcon";

// Material UI
import Grid from "@mui/material/Grid";

// Themes
import theme from "../../themes/mdc-theme";
import { COMPONENT_IDS } from "../../constants/RolePermissions";

const styles = () => ({
  alert: alertCSS,
  alertInfo: alertInfoCSS,
  alertError: alertErrorCSS,
  numberPlate: {
    position: "absolute",
    top: "-4.5rem",
    left: "40%",
  },
  tabLabel: {
    width: "95%",
    float: "left",
    fontFamily: theme.palette.typography.fontFamily,
  },
  marginRight5: {
    marginRight: "5px",
  },
  marginRight3: {
    marginRight: "1.5rem",
  },
  tabIcon: {
    width: "5%",
    float: "right",
    marginTop: "-14px",
    marginRight: "-6px",
  },
  downloadDropdown: {
    "& .dropdown-menu": {
      minWidth: "21.875rem",
      maxWidth: "25rem",
    },
    "& .dropdown-toggle": {
      "&::after": {
        display: "none",
      },
    },
    "& .nav-link": {
      padding: "0 0.5rem !important",
    },
  },
  downloadItem: {
    display: "flex",
    alignItems: "center",
  },
  downloadItemLabel: {
    display: "inline-block",
    maxWidth: "16rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  qesDivider: {
    borderTop: `1px solid ${theme.palette.MDCColors.color23}`,
  },
  infoMsg: {
    width: "-webkit-fill-available",
    margin: "auto 1rem",
  },
  fullPageLoader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "80vh",
  },
  detailDialog: {
    // To make content scrollable and of fixed height in Detail Dialog tabs
    "& .tab-content": {
      height: "56vh",
      overflow: "auto",
    },
  },
  hashErrorLineHeight: {
    lineHeight: 1.3,
  },
});
const tenantAlias = getActiveUserTenantAlias();
class VorgangeDetailsDialog extends React.Component {
  constructor(props) {
    super(props);
    // Add context identification to prevent state conflicts with ManualRequestForm
    this.componentContext = COMPONENT_CONTEXTS.VORGANGE_DETAILS;

    // Get isolated form defaults
    const isolatedForms = createIsolatedFormDefaults(this.componentContext);

    this.state = {
      showLoader: true,
      activeStep: 0,
      requestId: "",
      messageFor: ABORT,
      displayMessage: false,
      mandatoryFieldError: false,
      redirectState: false,
      displayActivityWindow: false,
      buttonDisabled: !this.props?.user?.roles?.includes(USER_ROLE_APPROVER),
      weiterleitenDissabled: !this.props?.user?.employeeId,
      pullRequestDissabled: true,
      defaultTabName: "Vorgangsdaten",
      vorgangeDetailsData: {},
      licensePlateF: "",
      licensePlateM: "",
      licensePlateL: "",
      selectedFileType: "xml",
      globalMessages: [],
      isWeiterleitenDisabled: false,
      // Isolated form data specific to VorgangeDetailsDialog context
      ...isolatedForms,
      displayPopup: false,
      isDownloadBtnOpen: false,
      operationIdsOptions: [],
      wirtschaftsDataOptions: [],
      registrationDate: "",
      registrationProcessedDate: "",
      employeeId: "",
      showFullPageLoader: true,
      countriesList: [{ label: "", value: "" }],
      displayVerwefenDialog: false,
      halterFormOperationIds: [],
      isZustellungZBError: false,
      openDataRegistrationModal: false,
      showSuccessHeading: false,
      displayMessages: [],
      isVollmachtTabDissable: true,
      isArchiveDialogOpen: false,
      showArchiveRecordLoader: false,
      // State isolation flag
      isStateIsolated: true,
    };
  }
  componentDidMount() {
    const requestId = this.props?.rowDetails?.requestId;
    if (requestId) {
      // To fetch all operations Id mapped to that  particular logged in user
      this.props.getQESProviders();

      const sessionActiveUser = JSON.parse(
        sessionStorage.getItem("activeUser")
      );

      const tenantGroupData = {
        groupId: sessionActiveUser?.groupID,
        value: sessionActiveUser?.value,
      };

      this.props
        .getOperationIDs(
          {},
          sessionActiveUser?.value ? sessionActiveUser?.value : tenantAlias,
          tenantGroupData
        )
        .then((resp) => {
          this.computeOperationIdsOptions(resp);
        });
      //To get the Details of that individual request
      this.props.getIndividualVorgangeDetails(this.props.rowDetails?.requestId);

      const requestType = this.props?.rowDetails?.vorgangsart;

      ["NZ", "TZ", "UM", "HA", "WZ", "UG", "WG"].includes(requestType) &&
        this.props.vollmachtTabValidation(requestId); // Call Vollmacht Status API only for NZ request and ReRegistration(UM/WZ) request

      // To fetch Steuerbefreiung Data
      this.props.getSteuerbefreiungData();

      if (this.props.rowDetails.requestId) {
        this.props.getVollmachtSigningStatus(this.props.rowDetails.requestId);
      }

      if (this.props?.vollmachtTabStatus) {
        this.setState({
          isVollmachtTabDissable: !this.props?.vollmachtTabStatus,
        });
      }

      this.getCountriesList();
      //get the company details in case of company person in halterRequestFormData (form 4)
      (this.props?.rowDetails?.vorgangsart === "NZ" ||
        this.props?.rowDetails?.vorgangsart === "TZ") &&
        this.props.getCompanyDetails(this.props.user.pTenantAlias);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props?.companyDetails &&
      this.props?.companyDetails !== prevProps?.companyDetails
    ) {
      this.companyDetails = this.props.companyDetails;
    }

    // Only process vorgangeDetails if it's specifically for this dialog context
    if (this.props?.vorgangeDetails !== prevProps?.vorgangeDetails) {
      if (
        this.props?.vorgangeDetails?.data &&
        this.props?.vorgangeDetails?.status === 200 &&
        this.state.isStateIsolated // Ensure this is for the details dialog
      ) {
        let formData = this.props.vorgangeDetails.data;
        this.setState({
          requestId: this.props.rowDetails.requestId,
        });
        this.setValuesInObjectIsolated(formData, this.state.requestId);

        if (formData.licensePlate) {
          this.handleLicensePlate(formData.licensePlate);
        }

        //  For getting the timestamp for qes files if it's a qes completed request for NZ/UM/WZ request type
        ["NZ", "TZ", "UM", "HA", "WZ", "UG", "WG"].includes(
          this.props.rowDetails?.vorgangsart
        ) &&
          this.props.getVollmachtSigningStatus(this.props.rowDetails.requestId);

        if (formData.registrationDate && formData.employeeId) {
          this.setState({
            registrationDate: formData.registrationDate,
            employeeId: formData.employeeId,
          });
        }

        if (formData?.registrationProcessedDate) {
          this.setState({
            registrationProcessedDate: formData?.registrationProcessedDate,
          });
        }
        this.setState({ showFullPageLoader: false });
      } else if (this.props?.vorgangeDetails?.status !== 200) {
        //If Api fails and give status other than success the close dialog
        this.closeDialogAndHideLoader();
      }
      this.setState({
        weiterleitenDissabled: !this.props.user.employeeId,
      });

      this.setState({ showLoader: false });
    }
  }
  componentWillUnmount() {
    //For resetting the vorgangDetails Reducer every time the Dialog closes/unmounts
    this.props.resetIndividualVorgangeDetails();
  }

  getCountriesList = () => {
    this.props.getCountriesList().then((resp) => {
      if (resp?.data) {
        const countriesList = resp?.data?.map(
          ({ countryName, countryCode }) => ({
            label: countryName,
            value: countryCode,
          }) // changed countryName and countryCode keys in label and value keys according to our project standards.
        );
        countriesList.unshift({ label: "", value: "" }); // for not selecting any country in dropdown
        this.setState({
          countriesList,
        });
      }
    });
  };

  companyDetails = {};

  //set value in object once get response
  setValuesInObject(object, requestId) {
    //antrag Form
    this.setState({
      antragRequestFormData: updateStateObject(
        antragDefaultForm,
        getTabObjects(formTag[0], object),
        0,
        requestId,
        this.companyDetails
      ),
    });

    //fahrzeug form
    this.setState({
      fahrzeugRequestFormData: updateStateObject(
        fahrzeugDefaultForm,
        getTabObjects(formTag[1], object),
        1,
        requestId,
        this.companyDetails
      ),
    });
    //kennzeichen form
    this.setState({
      kennzeichenRequestFormData: updateStateObject(
        kennzeichenDefaultForm,
        getTabObjects(formTag[2], object),
        2,
        requestId,
        this.companyDetails
      ),
    });
    // halter form
    this.setState({
      halterRequestFormData: updateStateObject(
        halterDefaultForm,
        getTabObjects(formTag[3], object),
        3,
        requestId,
        this.companyDetails,
        this.state.antragRequestFormData.personenform
      ),
    });

    this.setState({
      vollmachtRequestFormData: updateStateObject(
        vollmachtDefaultForm,
        getTabObjects(formTag[4], object),
        4,
        requestId,
        this.companyDetails
      ),
    });

    if (object?.messages && object?.messages?.length) {
      this.setState({ globalMessages: object?.messages });
    }
  }

  // Isolated state management method for VorgangeDetailsDialog
  setValuesInObjectIsolated(object, requestId) {
    // Create deep copies to prevent reference sharing
    const antragForm = JSON.parse(JSON.stringify(antragDefaultForm));
    const fahrzeugForm = JSON.parse(JSON.stringify(fahrzeugDefaultForm));
    const kennzeichenForm = JSON.parse(JSON.stringify(kennzeichenDefaultForm));
    const halterForm = JSON.parse(JSON.stringify(halterDefaultForm));
    const vollmachtForm = JSON.parse(JSON.stringify(vollmachtDefaultForm));

    //antrag Form - isolated
    this.setState({
      antragRequestFormData: updateStateObject(
        antragForm,
        getTabObjects(formTag[0], object),
        0,
        requestId + "_details", // Add context suffix
        this.companyDetails
      ),
    });

    //fahrzeug form - isolated
    this.setState({
      fahrzeugRequestFormData: updateStateObject(
        fahrzeugForm,
        getTabObjects(formTag[1], object),
        1,
        requestId + "_details", // Add context suffix
        this.companyDetails
      ),
    });

    //kennzeichen form - isolated
    this.setState({
      kennzeichenRequestFormData: updateStateObject(
        kennzeichenForm,
        getTabObjects(formTag[2], object),
        2,
        requestId + "_details", // Add context suffix
        this.companyDetails
      ),
    });

    // halter form - isolated
    this.setState({
      halterRequestFormData: updateStateObject(
        halterForm,
        getTabObjects(formTag[3], object),
        3,
        requestId + "_details", // Add context suffix
        this.companyDetails,
        this.state.antragRequestFormData.personenform
      ),
    });

    this.setState({
      vollmachtRequestFormData: updateStateObject(
        vollmachtForm,
        getTabObjects(formTag[4], object),
        4,
        requestId + "_details", // Add context suffix
        this.companyDetails
      ),
    });

    if (object?.messages && object?.messages?.length) {
      this.setState({ globalMessages: object?.messages });
    }
  }

  // Splitting license plate into three part or set in state
  handleLicensePlate(licensePlate) {
    let licensePlateF = licensePlate?.substr(0, 3).trim(),
      licensePlateM = licensePlate?.substr(3, 2).trim(),
      licensePlateL = licensePlate?.substr(5).trim();

    const isELicensePlate = licensePlateL.includes("E");

    licensePlateL =
      isELicensePlate && !licensePlateL.includes("?")
        ? licensePlateL.replace("E", "")
        : licensePlateL;

    this.setState({
      licensePlateF: licensePlateF || "",
      licensePlateM: licensePlateM || "",
      licensePlateL: licensePlateL || "",
      isELicensePlate: isELicensePlate,
    });
  }

  handlePopupClose = () => {
    this.setState({ displayPopup: false });
  };

  handleErrorDetailsPopupClose = () => {
    this.setState({
      displayMessagesModal: false,
      displayMessages: [],
      showSuccessHeading: false,
    });
  };

  handleRegistration = () => {
    if (
      ["NZ", "TZ", "UM", "HA", "AB", "WZ", "UG", "WG"].includes(
        this.state?.antragRequestFormData?.vorgangsart?.value
      )
    ) {
      this.setState({ displayPopup: true });
    }
  };

  handleDataRegistration = () => {
    this.setState({ openDataRegistrationModal: true });
  };

  handlePullRequest = (id) => {
    this.setState({ showLoader: true, showFullPageLoader: true });
    this.props.handlePullRequest(id).then(() => {
      this.closeDialogAndHideLoader(true);
    });
  };

  handleRejection = (id) => {
    this.setState({
      requestId: id,
      displayVerwefenDialog: true,
    });
  };

  closeDialogAndHideLoader = (isTableReload) => {
    this.props.handleDialogClose(isTableReload);
    this.setState({ showLoader: false });
  };

  downloadBlobData = (fileData, fileName, fileType) => {
    const url = window.URL.createObjectURL(
      new Blob([fileData], { type: "application/pdf" })
    );
    let downloadedFileName = fileType?.length
      ? `${fileName}.${fileType}`
      : fileName;
    downloadFileWithBlobURL(url, downloadedFileName);
  };

  showNoDownloadContentMessage = () => {
    toast.error(NO_CONTENT_FILE_DOWNLOAD);
    return;
  };

  //get document  based on file type
  getDocumentProps = (fileType) => {
    return fileType === "sepa"
      ? this.state.vollmachtRequestFormData?.sepaMandat?.value
      : fileType === "poa"
      ? this.state.vollmachtRequestFormData?.dauervollmacht?.value
      : this.state?.halterRequestFormData?.addressDocument?.value;
  };

  //Call to download api
  downloadFile = (fileType, fileName) => {
    if (
      fileType === "sepa" ||
      fileType === "poa" ||
      fileType === "addressDocument"
    ) {
      let base64String = this.getDocumentProps(fileType);
      const blobURL = convertBase64StringToBlobURL(base64String, PDF_FILE_TYPE);
      downloadFileWithBlobURL(blobURL, fileName);
    } else if (
      fileType === TEIL1 ||
      fileType === TEIL2 ||
      fileType === TEIL3 ||
      fileType === abmeldebescheinigung
    ) {
      this.props
        .getZulassungsbescheinigungDocuments(
          this.state.requestId,
          fileType === TEIL1
            ? TEIL1_ENDPOINT
            : fileType === TEIL3
            ? TEIL3_ENDPOINT
            : fileType === abmeldebescheinigung
            ? abmeldebescheinigung
            : TEIL2_ENDPOINT
        )
        .then((resp) => {
          if (resp?.status === 204) {
            this.showNoDownloadContentMessage();
          }
          if (resp?.status === 200) {
            this.downloadBlobData(
              resp?.data,
              getFileNameFromHttpResponse(resp)
            );
          }
        });
    } else if (fileType === "xml") {
      this.props.getRegisterDatenXML(this.state.requestId).then((response) => {
        if (response?.status === 204) {
          this.showNoDownloadContentMessage();
        }
        const xmlData = this.props.vorgangeDetailsReducer.registerDatenXmlData;
        if (xmlData?.status === 200) {
          const url = window.URL.createObjectURL(new Blob([xmlData.data]));
          downloadFileWithBlobURL(
            url,
            `${xmlData.headers["x-suggested-filename"]}`
          );
        }
      });
    } else {
      let interneVorgangsNummer =
        this.state.antragRequestFormData.referenzID_23?.value; //getting it for downloaded file name

      this.props
        .downloadFile(this.state.requestId, fileType)
        .then((response) => {
          if (response?.status === 204) {
            this.showNoDownloadContentMessage();
          }
          if (this.props.fileData && this.props.fileData !== null) {
            this.downloadBlobData(
              this.props.fileData,
              interneVorgangsNummer,
              fileType
            );
          }
        });
    }
  };
  handleFileSelection = (e) => {
    this.setState({ selectedFileType: e.target.value });
  };

  handleMessageClose = (userConformation) => {
    this.setState({ displayMessage: false, messageFor: ABORT });
    if (userConformation === true) {
      this.setState({ showLoader: true, showFullPageLoader: true });
      this.props.handleRejection(this.state.requestId).then(() => {
        this.closeDialogAndHideLoader(true);
      });
    }
  };

  handleVerwerfenClose = () => {
    this.setState({
      displayVerwefenDialog: false,
    });
  };

  handleVerwerfenSubmit = () => {
    this.setState({
      displayVerwefenDialog: false,
    });
    this.props.handleRejection(this.state.requestId).then(() => {
      this.closeDialogAndHideLoader(true);
    });
  };

  handleStep = (step) => {
    this.setState({ activeStep: step });
  };

  isFormDataHasError = (formIndex) => {
    switch (formIndex) {
      case 0:
        return this.state.antragRequestFormData.hasError ? true : false;
      case 1:
        return this.state.fahrzeugRequestFormData.hasError ? true : false;
      case 2:
        return this.state.kennzeichenRequestFormData.hasError ? true : false;
      case 3:
        return this.state.halterRequestFormData.hasError ? true : false;
      case 4:
        return this.state.vollmachtRequestFormData.hasError ? true : false;
      default:
        return false;
    }
  };

  getTabLabel = (label, index) => {
    const isVollmachtCompleted =
      this.props?.vollmachtSigningStatus?.currentStage ===
        QES_CURRENT_STAGE.SIGN &&
      this.props?.vollmachtSigningStatus?.stageStatus ===
        QES_STAGE_STATUS.COMPLETED;

    const icon = this.isFormDataHasError(index)
      ? errorIcon
      : index === this.state.activeStep
      ? blackCheckIcon
      : checkIcon;

    const { classes } = this.props;
    return (
      <div>
        <div className={classes.tabLabel}>
          {this.state.requestId && (
            <img src={icon} alt="error" className={classes.marginRight5} />
          )}
          {label}
        </div>
        <div className={classes.tabIcon}>
          {index !== 2 && isVollmachtCompleted ? (
            <MDCTooltip title="Vollmachtsrelevant">
              <img
                src={
                  index === this.state.activeStep
                    ? iconQESCompletionBlack
                    : iconQESCompletionGreen
                }
                alt="Vollmachtsrelevant"
              />
            </MDCTooltip>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  getErrorMessage = (errorMessageArray, isHashMessagePresent, messageCount) => {
    if (errorMessageArray.length === 0) {
      return "";
    } else {
      return `${
        isHashMessagePresent
          ? `${messageCount - 1} ${
              MessageDetailsDialogConstants.ERROR_DETAILS_WITH_HASH_STATEMENT
            }`
          : `${messageCount} ${MessageDetailsDialogConstants.ERROR_DETAILS_STATEMENT}`
      }`;
    }
  };

  getSuccessMessage = (classes) => {
    return (
      <Grid container marginTop="1rem">
        <div
          className={`${classes.alert} ${classes.alertInfo} ${classes.infoMsg}`}
        >
          <span>
            Dieser Antrag wurde via Großkundenschnittstelle eingereicht.
          </span>
        </div>
      </Grid>
    );
  };

  closeDialog = () => {
    // Clean up isolated state to prevent memory leaks and state contamination
    const cleanState = cleanupIsolatedState(this.componentContext);
    this.setState(cleanState);

    // FYI, If vorgang list status and vorgange list status are different, Call Vorgange List API call
    if (
      this.props.rowDetails?.status !==
      this.state.antragRequestFormData?.status?.value
    ) {
      this.props.handleDialogClose(true);
    }
    this.props.handleDialogClose();
  };
  handleLoader = (param) => {
    this.setState({ showLoader: param, showFullPageLoader: param });
  };
  computeOperationIdsOptions = (resp) => {
    if (resp?.status === 200 && resp?.data?.length) {
      this.setState({ halterFormOperationIds: resp?.data });
      const options = [];
      resp?.data.map((item) => {
        options.push({
          label: `${item?.operationName?.value},${item?.operationId?.value}`,
          value: item?.operationId?.value,
        });
      });
      this.setState({
        operationIdsOptions: options,
      });
      // If there is only 1 operation id in list then it should be pre-selected in dropdown
      options.length === 1 &&
        this.setState({
          antragRequestFormData: Object.assign(
            {},
            this.state.antragRequestFormData,
            {
              betriebsnummern: {
                value: options[0].value,
                error: "",
              },
            }
          ),
        });
    }
  };
  getRegistrationDateAndEmpID = () => {
    const { employeeId, registrationDate, registrationProcessedDate } =
      this.state;

    return (
      <Grid
        container
        justifyContent="flex-end"
        paddingRight="2rem"
        color={theme.palette.MDCColors.color23}
      >
        <Grid display="flex" flexDirection="column" alignItems={"end"}>
          {employeeId && registrationDate && (
            <Grid>
              Eingereicht von/am: {employeeId}/
              {`${moment(registrationDate).format("DD.MM.YYYY")} -
              ${moment(registrationDate).format("HH:mm")} Uhr `}
            </Grid>
          )}

          {registrationProcessedDate && (
            <Grid>
              Bescheid erhalten am:{" "}
              {`${moment(registrationProcessedDate).format("DD.MM.YYYY")} -
              ${moment(registrationProcessedDate).format("HH:mm")} Uhr `}
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  renderFileDownload = (classes, file, index) => {
    return (
      <NavDropdown.Item
        className={classes.downloadItem}
        key={index}
        onClick={() => this.downloadFile(file?.type, file?.name)}
      >
        <img
          src={DownloadImage}
          className={classes.marginRight3}
          alt={file?.name}
        />
        <span className={classes.downloadItemLabel}>{file?.name}</span>
      </NavDropdown.Item>
    );
  };

  //update fields after ident data from QES process
  updateManualRequestFormField = () => {
    this.props.getIndividualVorgangeDetails(this.state.requestId);
  };

  handleArchivedRecord = () => {
    this.setState({ showArchiveRecordLoader: true });
    this.props.archiveFehlerRecord(this.state.requestId).then((resp) => {
      if (HTTP_SUCCESS_CODE_200 === resp?.status) {
        history.push("/manual-request", {
          requestId: this.state.requestId,
          showGlobalMessages: true,
        });
      } else {
        this.setState({
          showArchiveRecordLoader: false,
          isArchiveDialogOpen: false,
        });
      }
    });
  };

  render() {
    let currentStatus = this.state.antragRequestFormData?.status?.value;
    let vorgangsart = this.state.antragRequestFormData?.vorgangsart;
    const personenform = this.state?.antragRequestFormData?.personenform?.value;

    const { classes } = this.props;
    const isSupportUserRole =
      this.props?.user?.roles?.includes(USER_ROLE_SUPPORT);
    const isOnlyAdminUserRole =
      this.props?.user?.roles?.includes(USER_ROLE_ADMIN) &&
      !this.props?.user?.roles?.includes(USER_ROLE_APPROVER);
    const isQESIconDisplay =
      this.state?.vollmachtRequestFormData?.unterzeichnungsprozess?.value ===
      "Qes";

    const isVollmachtCompleted =
      this.props?.vollmachtSigningStatus?.currentStage ===
        QES_CURRENT_STAGE.SIGN &&
      this.props?.vollmachtSigningStatus?.stageStatus ===
        QES_STAGE_STATUS.COMPLETED;

    const qesCompletedStage = this.props?.vollmachtSigningStatus?.currentStage;
    const qesStageStatus = this.props?.vollmachtSigningStatus?.stageStatus;

    const isAllowedToDelete = hasRolePermissions(
      COMPONENT_IDS.DASHBOARD,
      "delete"
    );

    const showDownloadsButton =
      currentStatus === VORGANT_STATUS_GENEHMIGT ||
      currentStatus === VORGANT_STATUS_ABGELEHNT ||
      isVollmachtCompleted;

    const tenantOwnsGKSNumber = this.props?.companyDetails?.tenantOwnsGKSNumber;

    const isTenantBlocked =
      this.props?.companyDetails?.tenantStatus === TENANT_STATUSES?.Gesperrt
        ? true
        : false;

    const hideVollmachtForm =
      ["NZ", "TZ", "UM", "HA", "WZ", "UG", "WG"].includes(vorgangsart?.value) &&
      personenform === "juristische" &&
      tenantOwnsGKSNumber &&
      this.state.halterRequestFormData.halterAddress?.value ===
        this.props?.companyDetails?.name;

    const disableVollMachtForm =
      personenform === "naturliche" &&
      this.state.isVollmachtTabDissable &&
      !isVollmachtCompleted;

    const displayDownloadFiles = () => {
      const isPassportAddressProof =
        this.state.halterRequestFormData?.reisepass?.value === "ja";

      return (
        <>
          {isVollmachtCompleted &&
            QESFilesName.map((file) => {
              return (
                <React.Fragment key={file.type}>
                  {(this.state.halterRequestFormData?.Vorhanden.value ||
                    this.state.halterRequestFormData.steuerbefreiung.value !==
                      "") &&
                  file.type === "sepa" ? null : (
                    <NavDropdown.Item
                      className={classes.downloadItem}
                      onClick={() => {
                        this.downloadFile(
                          file.type,
                          file?.name === "Vollmachtsantrag"
                            ? this.state.vollmachtRequestFormData
                                ?.vollmachtsprozess?.value
                            : file?.name
                        );
                      }}
                    >
                      <img
                        src={DownloadImage}
                        alt=""
                        className={classes.marginRight3}
                      />
                      <span className={classes.downloadItemLabel}>
                        {file?.name === "Vollmachtsantrag"
                          ? this.state.vollmachtRequestFormData
                              ?.vollmachtsprozess?.value
                          : file?.name}
                      </span>
                    </NavDropdown.Item>
                  )}
                </React.Fragment>
              );
            })}
          {isVollmachtCompleted &&
            RRCDocumentFilesName.filter(
              () => this.state.halterRequestFormData?.addressDocument?.value
            ).map((file, index) =>
              this.renderFileDownload(classes, file, index)
            )}

          {currentStatus === VORGANT_STATUS_GENEHMIGT &&
            DataRegistrationFilesName.map((file, index) =>
              this.renderFileDownload(classes, file, index)
            )}

          {vorgangsart?.value !== "AB" &&
            currentStatus === VORGANT_STATUS_GENEHMIGT &&
            ZulassungsFilesName.map((file, index) =>
              this.renderFileDownload(classes, file, index)
            )}

          {vorgangsart?.value === "AB" &&
            currentStatus === VORGANT_STATUS_GENEHMIGT &&
            ABZulassungsFilesName.map((file, index) =>
              this.renderFileDownload(classes, file, index)
            )}

          {currentStatus === VORGANT_STATUS_ABGELEHNT &&
            RejectedAbgelehntFilesName.map((file, index) =>
              this.renderFileDownload(classes, file, index)
            )}
        </>
      );
    };

    const showGebuhrenDetailsTab = () => {
      // We need enable once we get the real time in future
      return false;
      // return currentStatus === "Genehmigt" || currentStatus === "Abgelehnt";
    };

    const showCloneRecordButton =
      [
        VORGANT_STATUS_FEHLER,
        VORGANT_STATUS_FEHLER_B,
        VORGANT_STATUS_FEHLER_T,
      ].includes(currentStatus) &&
      !this.props?.rowDetails?.archived &&
      this.props?.user?.roles?.includes(USER_ROLE_APPROVER) &&
      this.state.antragRequestFormData?.antragsnummer?.value?.length
        ? true
        : false;

    return (
      <div>
        <MDCModal
          id="details-modal"
          size="xl"
          open={this.props.show}
          isDetailDialog
          title={
            <Grid className={classes.numberPlate}>
              <MDCLicensePlate
                licensePlateF={this.state?.licensePlateF}
                licensePlateM={this.state.licensePlateM}
                licensePlateL={this.state?.licensePlateL}
                isELicensePlate={this.state?.isELicensePlate}
              />
            </Grid>
          }
          body={
            <div className={this.props?.classes?.detailDialog}>
              {this.state.showFullPageLoader ? (
                <Grid className={this.props?.classes?.fullPageLoader}>
                  <MDCLoader />
                </Grid>
              ) : (
                <Tabs
                  defaultActiveKey={this.state.activeStep}
                  className="nav-justified"
                  onSelect={(tab) => this.handleStep(+tab)}
                >
                  <Tab
                    key={0}
                    eventKey={0}
                    title={this.getTabLabel("Vorgangsdaten", 0)}
                  >
                    <>
                      <AntragRequestForm
                        formValues={this.state.antragRequestFormData}
                        vorgangsart={vorgangsart}
                        readOnly
                        isDetailDialog
                        isQESIconDisplay={isQESIconDisplay}
                        isVollmachtCompleted={isVollmachtCompleted}
                        requestId={this.state.requestId}
                        operationIdsOptions={this.state.operationIdsOptions}
                        isZustellungZBError={this.state.isZustellungZBError} //Generic error flag for ZB address fields
                        registrationApprovalDate={
                          this.props?.vorgangeDetails?.data
                            ?.registrationApprovalDate
                        }
                        showRegistrationApprovalDate={[
                          "Genehmigt",
                          "Abgelehnt",
                        ].includes(currentStatus)}
                        globalMessages={this.state.globalMessages}
                        isArchivedRecord={this.props?.rowDetails?.archived}
                        componentContext={this.componentContext}
                      />

                      {["Eingereicht", "Genehmigt", "Abgelehnt"].includes(
                        currentStatus
                      ) && this.getRegistrationDateAndEmpID()}
                    </>
                  </Tab>
                  <Tab
                    key={1}
                    eventKey={1}
                    title={this.getTabLabel("Fahrzeugidentifizierung", 1)}
                  >
                    <FahrzeugRequestForm
                      formValues={this.state.fahrzeugRequestFormData}
                      vorgangsart={vorgangsart}
                      readOnly
                      isDetailDialog
                      isQESIconDisplay={isQESIconDisplay}
                      isVollmachtCompleted={isVollmachtCompleted}
                      countriesList={this.state.countriesList}
                      ummeldungOldKennzeichenRetained={
                        this.state.kennzeichenRequestFormData
                          ?.UmmeldungOldKennzeichenRetained?.value
                      }
                      globalMessages={this.state.globalMessages}
                      componentContext={this.componentContext}
                    />
                  </Tab>
                  <Tab
                    key={2}
                    eventKey={2}
                    title={this.getTabLabel("Kennzeichen", 2)}
                  >
                    <KennzeichenRequestForm
                      formValues={this.state.kennzeichenRequestFormData}
                      vorgangsart={vorgangsart}
                      readOnly
                      isDetailDialog
                      merkmalverwertungsnachweis={
                        this.state.fahrzeugRequestFormData
                          ?.merkmalverwertungsnachweis?.value
                      }
                      requestId={this.state.requestId}
                      status={this.state.antragRequestFormData?.status?.value}
                      operationIdsOptions={
                        this?.state?.halterFormOperationIds || []
                      }
                      globalMessages={this.state.globalMessages}
                      licensePlateOrderActive={
                        this.props.companyDetails?.licensePlateOrderActive
                      }
                      componentContext={this.componentContext}
                    />
                  </Tab>
                  {this.state.antragRequestFormData.vorgangsart.value !==
                    "AB" && (
                    <Tab
                      key={3}
                      eventKey={3}
                      title={this.getTabLabel("Fahrzeughalter", 3)}
                    >
                      <HalterRequestForm
                        formValues={this.state.halterRequestFormData}
                        vollmachtFormValues={
                          this.state.vollmachtRequestFormData
                        }
                        vorgangsart={vorgangsart}
                        readOnly
                        isDetailDialog
                        personenform={
                          this.state.antragRequestFormData.personenform
                        }
                        isQESIconDisplay={isQESIconDisplay}
                        isVollmachtCompleted={isVollmachtCompleted}
                        companyDetails={this.props?.companyDetails}
                        qesCompletedStage={qesCompletedStage}
                        qesStageStatus={qesStageStatus}
                        halterFormOperationIds={
                          this.state.halterFormOperationIds
                        }
                        representativeInfo={
                          this.state.vollmachtRequestFormData
                            ?.gesetztlicherVertreter?.value
                        }
                        operationIdsOptions={this.state.operationIdsOptions}
                        globalMessages={this.state.globalMessages}
                        componentContext={this.componentContext}
                      />
                    </Tab>
                  )}
                  {this.state.antragRequestFormData.vorgangsart.value !==
                    "AB" &&
                    (!hideVollmachtForm || disableVollMachtForm) && (
                      <Tab
                        key={4}
                        eventKey={4}
                        title={this.getTabLabel("Vollmacht", 4)}
                      >
                        <>
                          <VollmachtTab
                            vorgangsart={
                              this.state.antragRequestFormData.vorgangsart
                                ?.value
                            }
                            personenform={
                              this.state?.antragRequestFormData?.personenform
                                ?.value
                            }
                            isDetailDialog
                            readOnly={false}
                            requestId={this.state.requestId}
                            updateManualRequestFormField={
                              this.updateManualRequestFormField
                            }
                            isVollmachtCompleted={isVollmachtCompleted}
                            halterFormValues={this.state.halterRequestFormData}
                            formValues={this.state.vollmachtRequestFormData}
                            isVollmachtTabDissable={
                              this.state.isVollmachtTabDissable
                            }
                            vollmachtSigningStatus={
                              this.props?.vollmachtSigningStatus
                            }
                            vollmachtTabStatus={this.props?.vollmachtTabStatus}
                            isPpoaApplied={
                              this.state.vollmachtRequestFormData
                                ?.dauervollmachtId?.value !== ""
                            } //If PPOA is assigned then dauervollmachtId will not be empty
                            componentContext={this.componentContext}
                          />
                        </>
                      </Tab>
                    )}

                  {showGebuhrenDetailsTab() && (
                    <Tab
                      key={4}
                      eventKey={4}
                      title={this.getTabLabel("GEBÜHRENDETAILS", 4)}
                    >
                      <>
                        {this.getSuccessMessage(classes)}
                        <GebuhrenDetails />
                      </>
                    </Tab>
                  )}
                </Tabs>
              )}
            </div>
          }
          footer={
            !this.state.showLoader && (
              <>
                <Grid container mb={4} paddingX="1rem">
                  <Grid item xs={4}>
                    <MDCButton
                      variant="outlined"
                      label={"Schließen"}
                      onClick={this.closeDialog}
                    />
                  </Grid>

                  <Grid item xs={8}>
                    {!this.state.showLoader &&
                      this.props.activeTab !== "archiv" && (
                        <Grid container justifyContent="flex-end">
                          {currentStatus === VORGANT_STATUS_GENEHMIGT && (
                            <MDCButton
                              variant="outlined"
                              label={"Registerdaten anzeigen"}
                              disabled={false}
                              onClick={() => {
                                this.handleDataRegistration();
                              }}
                              endIcon={<ButtonDocumentIcon />}
                            />
                          )}
                          {currentStatus === VORGANT_STATUS_VERSANDFERTIG && (
                            <>
                              <MDCButton
                                variant="outlined"
                                label={"Verwerfen"}
                                onClick={() =>
                                  this.handleRejection(this.state.requestId)
                                }
                                endIcon={<BlockIcon />}
                                disabled={
                                  isSupportUserRole ||
                                  isOnlyAdminUserRole ||
                                  !isAllowedToDelete
                                }
                              />
                              <MDCButton
                                variant="contained"
                                label={"Einreichen"}
                                disabled={
                                  this.state.buttonDisabled ||
                                  this.state.weiterleitenDissabled ||
                                  this.props?.rowDetails?.processing ||
                                  isTenantBlocked
                                }
                                onClick={() =>
                                  this.handleRegistration(this.state.requestId)
                                }
                                endIcon={<NextIcon />}
                              />
                            </>
                          )}
                          {currentStatus === VORGANT_STATUS_EINGEREICHT && (
                            <MDCButton
                              variant="outlined"
                              label={"Aktualisieren"}
                              disabled={
                                this.state.buttonDisabled ||
                                this.state.pullRequestDissabled
                              }
                              onClick={() =>
                                this.handlePullRequest(this.state.requestId)
                              }
                              endIcon={<RefreshIcon />}
                            />
                          )}
                          {currentStatus === VORGANT_STATUS_ABGELEHNT && (
                            <MDCButton
                              variant="contained"
                              label={"Antrag erneut bearbeiten"}
                              disabled={this.state.buttonDisabled}
                              onClick={() => {
                                history.push("/manual-request", {
                                  requestId: this.state.requestId,
                                  isAbelegentNewRequest: true,
                                  createNewRequest: true,
                                });
                              }}
                              endIcon={<EditIcon />}
                            />
                          )}

                          {showCloneRecordButton && (
                            <MDCButton
                              variant="outlined"
                              label={"Vorgang kopieren"}
                              onClick={() => {
                                this.setState({
                                  isArchiveDialogOpen: true,
                                });
                              }}
                              endIcon={<ArchiveIcon />}
                            />
                          )}

                          <div className={classes.downloadDropdown}>
                            {showDownloadsButton && (
                              <NavDropdown
                                direction="top"
                                title={
                                  <MDCButton
                                    variant={
                                      this.state.isDownloadBtnOpen
                                        ? "contained"
                                        : "outlined"
                                    }
                                    label={"Downloads"}
                                    endIcon={
                                      this.state.isDownloadBtnOpen ? (
                                        <DownArrowIcon />
                                      ) : (
                                        <UpArrowIcon />
                                      )
                                    }
                                  />
                                }
                                onToggle={(toggleValue) => {
                                  this.setState({
                                    isDownloadBtnOpen: toggleValue,
                                  });
                                }}
                              >
                                {displayDownloadFiles()}
                              </NavDropdown>
                            )}
                          </div>
                        </Grid>
                      )}
                  </Grid>
                </Grid>
              </>
            )
          }
        />

        <MassageDialog
          show={this.state.displayMessage}
          messageFor={this.state.messageFor}
          handleDialogClose={this.handleMessageClose}
          mandatoryFieldError={this.state.mandatoryFieldError}
          redirectState={this.state.redirectState}
        />

        <VerwerfenPopupDialog
          show={this.state.displayVerwefenDialog}
          requestId={this.state.requestId}
          handleVerwerfenClose={this.handleVerwerfenClose}
          handleVerwerfenSubmit={this.handleVerwerfenSubmit}
        />

        <PopupDialog
          certificateDetails={this.props?.companyDetails?.gksDetailsPresent}
          popUpHeading={ConfirmationPopupConstants.REGISTRATION_POPUP_HEADING}
          show={this.state.displayPopup}
          requestIds={[this.state.requestId]}
          handlePopupClose={this.handlePopupClose}
          handleLoader={this.handleLoader}
          handleDialogClose={this.props.handleDialogClose}
          isFromDetailView
        />
        {this.state.openDataRegistrationModal && (
          <DataRegistrationDialog
            show={this.state.openDataRegistrationModal}
            handlePopupClose={() =>
              this.setState({ openDataRegistrationModal: false })
            }
            requestId={this.state.requestId}
          />
        )}

        {this.state.isArchiveDialogOpen && (
          <ArchiveRecordDialog
            open={this.state.isArchiveDialogOpen}
            onCancel={() => this.setState({ isArchiveDialogOpen: false })}
            onConfirm={this.handleArchivedRecord}
            showLoader={this.state.showArchiveRecordLoader}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.authentication.companyDetails,
    vorgangeDetails: state.vorgangeDetailsReducer.vorgangeDetails,
    fileData: state.vorgangeDetailsReducer.fileData,
    vorgangeDetailsReducer: state.vorgangeDetailsReducer,
    user: state.authentication.user,
    sepaDocument: state.manualRequestFormReducer.sepaDocument,
    poaDocument: state.manualRequestFormReducer.poaDocument,
    vollmachtSigningStatus:
      state.manualRequestFormReducer.vollmachtSigningStatus,
    zbTeil1PDF: state.manualRequestFormReducer.zbTeil1PDF,
    zbTeil2PDF: state.manualRequestFormReducer.zbTeil2PDF,
    vollmachtTabStatus: state.manualRequestFormReducer.vollmachtTabStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getIndividualVorgangeDetails: (id) =>
      dispatch(vorgangeDetailsActions.getIndividualVorgangeDetails(id)),
    handleRejection: (id) =>
      dispatch(vorgangeDetailsActions.handleRejection(id)),
    handlePullRequest: (id) =>
      dispatch(vorgangeDetailsActions.handlePullRequest(id)),
    downloadFile: (requestId, fileType) =>
      dispatch(vorgangeDetailsActions.downloadFile(requestId, fileType)),
    getVollmachtSigningStatus: (requestId) =>
      dispatch(manualRequestFormActions.getVollmachtSigningStatus(requestId)),
    getVollmachtSignedDocuments: (requestId, docName) =>
      dispatch(
        manualRequestFormActions.getVollmachtSignedDocuments(requestId, docName)
      ),
    getZulassungsbescheinigungDocuments: (requestId, docName) =>
      dispatch(
        manualRequestFormActions.getZulassungsbescheinigungDocuments(
          requestId,
          docName
        )
      ),
    resetVollmachtSignedData: () =>
      dispatch(manualRequestFormActions.resetVollmachtSignedData()),
    // immutate getCompanyDetails because it cause problem in notification component.
    getCompanyDetails: (aliasName) =>
      dispatch(userActions.getCompanyDetails(aliasName)),
    getOperationIDs: (query, aliasName, tenantGroupData) =>
      dispatch(
        verimiAdminActions.getOperationIDs(query, aliasName, tenantGroupData)
      ),
    resetIndividualVorgangeDetails: () =>
      dispatch(vorgangeDetailsActions.resetIndividualVorgangeDetails()),
    getCountriesList: () =>
      dispatch(manualRequestFormActions.getCountriesList()),
    getSteuerbefreiungData: () =>
      dispatch(manualRequestFormActions.getSteuerbefreiungData()),
    getRegisterDatenXML: (requestId) =>
      dispatch(vorgangeDetailsActions.getRegisterDatenXML(requestId)),
    vollmachtTabValidation: (requestId) =>
      dispatch(manualRequestFormActions.vollmachtTabValidation(requestId)),
    archiveFehlerRecord: (requestId) =>
      dispatch(vorgangeDetailsActions.archiveFehlerRecord(requestId)),
    getQESProviders: () =>
      dispatch(VollmachtRequestFormAction.getQESProviders()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VorgangeDetailsDialog));
